export default __webpack_public_path__ + "static/media/image3.14ba6627.svg";